import { render } from "./QueryChat.vue?vue&type=template&id=13992f9c&scoped=true"
import script from "./QueryChat.vue?vue&type=script&lang=js"
export * from "./QueryChat.vue?vue&type=script&lang=js"

import "./QueryChat.vue?vue&type=style&index=0&id=13992f9c&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13992f9c"]])

export default __exports__